import { useState } from "react";

function InputPass({ onChange }) {

    const [text, setText] = useState("")
    const [eyeOpen, setEyeOpen] = useState(false)
    const inputHandler = (e) => {
        setText(e.target.value)
        onChange(e.target.value)
    }

    return (
        <div className="w-4/6 flex flex-row-reverse items-center ">
            <img
                src="/image/icon/password.png"
                className="w-7"
            />
            <div className="bg-purpleLight borderBlue w-full flex flex-row-reverse items-center mr-4 rounded">
                <input
                    value={text}
                    onChange={inputHandler}
                    type={eyeOpen ? "text" : "password"}
                    placeholder="رمز عبور"
                    className="text-right pr-4 text-xs bg-purpleLight py-3 w-11/12 rounded focus:outline-none"
                />
                {eyeOpen ?
                    <img
                        src="/image/icon/eyeOpen.png"
                        className="w-8 ml-2"
                        onClick={() => setEyeOpen(false)}
                    />
                    :
                    <img
                        src="/image/icon/eyeClose.png"
                        className="w-8 ml-2"
                        onClick={() => setEyeOpen(true)}
                    />
                }
            </div>
        </div>
    )
}
export default InputPass;